document.addEventListener('DOMContentLoaded', function () {
  // Mobile menu drawer
  var menuToggle = document.querySelector('[data-action="open-mobile-menu"]');
  var menuCloseEls = document.querySelectorAll('[data-action="close-mobile-menu"]');
  var drawer = document.querySelector('.mobile-menu-drawer');
  var steps = drawer ? drawer.querySelectorAll('.mobile-menu-drawer__step') : [];

  function goToStep(stepName) {
    steps.forEach(function (step) {
      step.classList.toggle('is-active', step.getAttribute('data-menu-step') === stepName);
    });
  }

  function openDrawer() {
    if (!drawer) return;
    // Position the panel just below the actual header (announcement bar + nav), whatever its real height is.
    var header = document.querySelector('.site-header');
    var headerBottom = header ? header.getBoundingClientRect().bottom : 96;
    drawer.style.setProperty('--drawer-top', Math.round(headerBottom + 40) + 'px');
    drawer.classList.add('is-open');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    // Reset back to the main step after the close transition finishes
    window.setTimeout(function () { goToStep('main'); }, 300);
  }

  if (menuToggle) menuToggle.addEventListener('click', openDrawer);
  menuCloseEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });

  if (drawer) {
    drawer.addEventListener('click', function (event) {
      var openBtn = event.target.closest('[data-action="open-menu-step"]');
      if (openBtn) {
        goToStep(openBtn.getAttribute('data-target-step'));
        return;
      }
      var backBtn = event.target.closest('[data-action="back-menu-step"]');
      if (backBtn) {
        goToStep(backBtn.getAttribute('data-target-step'));
      }
    });
  }

  // Product gallery thumbnail swap
  var mainImage = document.getElementById('ProductMainImage');
  var thumbs = document.querySelectorAll('.product-detail__thumb');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) {
        mainImage.src = thumb.getAttribute('data-full-src');
      }
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  // Product quantity stepper
  var qtyInput = document.getElementById('Quantity');
  var qtyButtons = document.querySelectorAll('.product-detail__qty-btn');
  qtyButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (!qtyInput) return;
      var current = parseInt(qtyInput.value, 10) || 1;
      if (btn.getAttribute('data-action') === 'increase-qty') {
        qtyInput.value = current + 1;
      } else {
        qtyInput.value = Math.max(1, current - 1);
      }
    });
  });

  // Product option value selection (visual state only; variant id updates need option->variant mapping)
  var optionValues = document.querySelectorAll('.product-detail__option-value');
  optionValues.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var group = btn.closest('.product-detail__option-values');
      if (group) {
        group.querySelectorAll('.product-detail__option-value').forEach(function (b) {
          b.classList.remove('is-selected');
        });
      }
      btn.classList.add('is-selected');
    });
  });
});
